<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            {{ $route.params.id ? "Edit Insurance" : "New Insurance" }}
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form @submit.prevent="save">
      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Employee Name (Emp ID)</label>
        <div class="col-md-7 pl-md-0">
          <Select2
            v-model="userId"
            :options="employees"
            v-if="role == 'admin'"
            required
          />
          <span v-else>{{ employees.length ? employees[0].text : this.loadingName }}</span>
        </div>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Insurance Year</label>
        <div class="col-md-7 pl-md-0">
          <select class="custom-select" v-model="year" required v-if="!this.isNewEmployee">
            <option value="">-- Please Select --</option>
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>

          <span v-if="this.isNewEmployee">{{ this.year }}</span>
        </div>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Type of Insurance</label>
        <div class="col-md-7 pl-md-0">
          <select class="custom-select" v-model="typeId" required>
            <option value="">-- Please Select --</option>
            <option v-for="item in types" :key="item.Id" :value="item.Id">
              {{ item.Description }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Enrolment Category</label>
        <div class="col-md-7 pl-md-0">
          <select class="custom-select" v-model="categoryId" required>
            <option value="">-- Please Select --</option>
            <option v-for="item in categories" :key="item.Id" :value="item.Id">
              {{ item.Description }}
            </option>
          </select>
        </div>
      </div>
      <div
        class="form-group row align-items-center"
        v-if="!isSpouseOnlySelected && categoryId"
      >
        <label class="col-md-3 mb-0">Number of Children</label>
        <div class="col-md-7 pl-md-0">
          <input
            type="number"
            class="form-control"
            v-model="noOfChildren"
            step="1"
            min="1"
            max="100"
            required
          />
        </div>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-md-3 mb-0">Admin Instructions</label>
        <div class="col-md-7 pl-md-0">
          <textarea class="form-control" rows="10" readonly v-html="enrolmentPeriod.Instruction"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <button
            type="button"
            class="btn btn-secondary"
            @click="$router.go(-1)"
          >
            <i class="fa fa-reply mr-2"></i>Back
          </button>
        </div>
        <div class="col-md-7 text-right">
          <button type="submit" class="btn btn-primary">
            <i v-if="$route.params.id" class="fa fa-save"></i>
            <i v-else class="fa fa-plus"></i>
            {{ $route.params.id ? "Save" : "Add" }}
          </button>
        </div>
      </div>
    </form>

    <!-- /Form -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import Select2 from "v-select2-component";
export default {
  components: { Select2 },
  data() {
    return {
      employees: [],
      years: [],
      types: [],
      categories: [],
      //form input
      userId: "",
      year: "",
      typeId: "",
      categoryId: "",
      noOfChildren: "",
      loadingName: config.LOADING_EMPLOYEE_NAME,
      enrolmentPeriodType: "Insurance",
      enrolmentPeriod: {
        Id: null,
        Instruction: "",
      },
      isNewEmployee: false
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    isSpouseOnlySelected() {
      let selectedCategory = this.categories.find(
        (c) => c.Id == this.categoryId
      );
      if (
        selectedCategory &&
        selectedCategory.Description.toLowerCase() == "spouse only"
      ) {
        return true;
      }
      return false;
    },
  },

  watch: {
    typeId(val) {
      if (!val) {
        this.categories = [];
        return;
      }
      let param = {
        Token: this.token,
        Id: val,
      };
      this.$store.state.isLoading = true;
      API.getInsuranceCategoryMappingEnrolmentCategories(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.categories = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },

  methods: {
    getEmployees() {
      let param = { Token: this.token };
      this.$store.state.isLoading = true;
      API.getEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.employees = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getYears() {
      let param = { Token: this.token };
      this.$store.state.isLoading = true;
      API.getYears(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.years = response.data.record;

            if ( this.isNewEmployee ) {
              this.year = response.data.record[0];
              // console.log("Insurance Year: " + this.year);
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getInsuranceTypes() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getInsuranceCategoryMappingInsuranceTypes(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.types = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getEmployeeInsurance() {
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.getEmployeeInsuranceDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.record) {
              let data = response.data.record;
              this.userId = data.UserId;
              this.year = data.Year;
              this.typeId = data.InsuranceTypeId;
              this.categoryId = data.EnrolmentCategoryId;
              this.noOfChildren = data.NumberOfChildren;
            } else {
              this.$router.replace({ name: "insuranceDependent" });
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
        UserId: this.role == "admin" ? this.userId : this.employees[0].id,
        InsuranceTypeId: this.typeId,
        EnrolmentCategoryId: this.categoryId,
        Year: this.year,
        NumberOfChildren: !this.isSpouseOnlySelected ? this.noOfChildren : null,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveEmployeeInsurance(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.$router.replace({ name: "insuranceDependent" });
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getEnrolmentPeriod() {
      let param = {
        Token: this.token,
        Type: this.enrolmentPeriodType,
      };
      this.$store.state.isLoading = true;
      API.getEnrolmentPeriod(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.record)
              this.enrolmentPeriod = response.data.record;

              if ( response.data.isNewEmployee ) {
                this.isNewEmployee = response.data.isNewEmployee;
              }

              if ( this.enrolmentPeriod.Instruction ) {
                this.enrolmentPeriod.Instruction = this.enrolmentPeriod.Instruction;
              }
              else {
                this.enrolmentPeriod.Instruction = "N.A.";
              }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }

          this.getYears();
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    if (this.role == "employee") {
      API.getEnrolmentPeriod({
        Token: this.token,
        Type: "Insurance",
        EmployeeInsuranceId: this.$route.params.id,
      })
        .then((response) => {
          if (response.data.success) {
            if (
              (!response.data.isEnrolmentOpen ||
              !response.data.isChangeAllowForEmployee) &&
              !response.data.isNewEmployee
            ) {
              this.$router.replace({ name: "insuranceDependent" });
              return;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }

          this.getYears();
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    }

    this.getEmployees();
    this.getInsuranceTypes();
    this.getEnrolmentPeriod();

    if (this.$route.params.id) this.getEmployeeInsurance(); //for edit mode
  },
};
</script>

<style scoped>
.col-md-3 {
  max-width: 220px;
}
</style>



// WEBPACK FOOTER //
// src/components/Insurance/InsuranceAndDependent/InsuranceEdit.vue